const muiCustomStyles = {
  headerBoxStyle: {
    justifyContent: { xs: "center", sm: "space-between" },
    paddingX: { xs: "16px", sm: "24px" },
    paddingY: "12px",
    boxShadow: { xs: "none", sm: "0px 3px 8px 0px rgba(47, 43, 61, 0.08)" },
    backgroundColor: { xs: "transparent", sm: "rgba(255, 255, 255, 1)" },
  },

  dialogStyle: {
    // maxHeight: { xs: "100%", sm: "800px" },
    "& .MuiPaper-root": {
      boxShadow: "none",
      maxWidth: "1200px",
      display: "flex",
      flexDirection: "column",
      borderRadius: "6px",
      backgroundColor: { xs: "transparent", sm: "rgba(255, 255, 255, 1)" },
      height: "max-content",
      margin: "32px",
    },
  },

  dialogBox: {
    maxHeight: { xs: "100%", sm: "800px" },
    overflow: "hidden",
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },

  dialogContent: {
    p: 0,
    flex: 1,
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    overflow: "hidden",
  },

  helpIconWrapper: {
    width: "28px",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  supplierFooterStyle: {
    display: { xs: "none", sm: "flex" },
    paddingY: "12px",
    paddingX: "24px",
    boxShadow: "0px -3px 8px 0px rgba(47, 43, 61, 0.08)",
  },
};

export default muiCustomStyles;
